type ProductEventName =
  | "page_view"
  | "command_clicked"
  | "refresh_clicked"
  | "feishu_open_clicked"
  | "requirement_viewed"
  | "agent_lane_viewed"
  | "workflow_step_viewed";

type ProductEvent = {
  event_name: ProductEventName;
  surface?: string;
  target?: string;
  properties?: Record<string, string | number | boolean | null | undefined>;
};

const seenViewEvents = new Set<string>();

export function trackEvent(event: ProductEvent) {
  if (isLocalDevHost()) return;

  if (event.event_name.endsWith("_viewed")) {
    const key = `${event.event_name}:${event.surface || ""}:${event.target || ""}`;
    if (seenViewEvents.has(key)) return;
    seenViewEvents.add(key);
  }

  const payload = {
    ...event,
    path: window.location.pathname,
    referrer: document.referrer,
    locale: navigator.language
  };

  const body = JSON.stringify(payload);
  if (navigator.sendBeacon) {
    const blob = new Blob([body], { type: "application/json" });
    if (navigator.sendBeacon("/api/events", blob)) return;
  }

  void fetch("/api/events", {
    method: "POST",
    headers: {
      "content-type": "application/json"
    },
    body,
    keepalive: true
  }).catch(() => {
    // Metrics should never block the product surface.
  });
}

function isLocalDevHost() {
  return ["localhost", "127.0.0.1", "0.0.0.0", "::1"].includes(window.location.hostname);
}
